import { HTMLAttributes } from "react";

export default function InputError({
    message,
    className = "",
    ...props
}: HTMLAttributes<HTMLParagraphElement> & { message?: string }) {
    return message ? (
        <p
            {...props}
            data-scroll-to-error
            className={"text-sm text-brand-red " + className}
        >
            {message}
        </p>
    ) : null;
}
